import oidcAuthApi from '~/domain/auth/api/oidc-auth-api';
import { clearUser } from '~/ducks/authentication/actions';
import type { AppStore } from '~/store/Store';
import type { AppState } from '~/reducers';
import { addServiceWorkerAuthErrorListener } from '~/utils/service-worker-utils/service-worker-utils';

export const installServiceWorkerAuthRefreshListener = (store: AppStore): void => {
  let authRefreshInFlight = false;

  addServiceWorkerAuthErrorListener(() => {
    if (authRefreshInFlight) {
      return;
    }

    authRefreshInFlight = true;
    const action = oidcAuthApi.endpoints.refreshCurrentUser.initiate(undefined, {
      forceRefetch: true,
    });

    const result = store.dispatch(action);
    void result
      .unwrap()
      .catch(() => {
        if ((store.getState() as AppState).authentication.authenticated) {
          store.dispatch(clearUser());
        }
      })
      .finally(() => {
        authRefreshInFlight = false;
      });
  });
};
